import { SpaceXl, BpMd, FontSize400, FontSize200, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { ONE_FOURTH_AD_TYPE, ONE_THIRD_AD_TYPE } from "./constants.js";
const getMultiAdStyles = (adBuilderData) => {
  const fallbackAdStyles = {
    display: "flex",
    gap: SpaceXl,
    width: "100%"
  };
  if (!adBuilderData) {
    return fallbackAdStyles;
  }
  switch (adBuilderData.ad_type) {
    case ONE_THIRD_AD_TYPE:
      return {
        display: "flex",
        gap: SpaceXl,
        gridTemplateColumns: `repeat(3, minmax(0, 1fr))`,
        [`@media (min-width: ${BpMd})`]: {
          display: "grid"
        }
      };
    case ONE_FOURTH_AD_TYPE:
      return {
        display: "grid",
        gap: SpaceXl,
        gridTemplateColumns: `repeat(2, minmax(0, 1fr))`,
        [`@media (min-width: ${BpMd})`]: {
          gridTemplateColumns: `repeat(4, minmax(0, 1fr))`
        }
      };
    default:
      return fallbackAdStyles;
  }
};
const staticMultiRowStyles = {
  imageContainerSx: {
    padding: { md: `0 ${SpaceMd}`, sm: `0` },
    display: "flex",
    justifyContent: "center",
    width: "100%"
  },
  imageBackgroundContainerSx: {
    height: "100%",
    width: "100%"
  },
  imageSx: {
    width: "100%",
    height: "100%"
  },
  linkSx: {
    width: "100%",
    padding: 0
  },
  titleSx: {
    fontSize: {
      sm: FontSize200,
      lg: FontSize400
    }
  }
};
export {
  getMultiAdStyles,
  staticMultiRowStyles
};
